import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import {
	useActiveRightSidebarState,
	useRightSidebarController,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import {
	PANEL_ID,
	PANEL_WIDTH,
} from '@atlassian/jira-onboarding-checklist-next/src/common/constants.tsx';
import { QUICKSTART_UI_STATUS } from '@atlassian/jira-onboarding-quickstart-core/src/common/constants.tsx';
import {
	useJswOnboarding,
	useQuickstartUiStatus,
} from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import { fireAnalyticsOnOpenRightHandSidebar } from '@atlassian/jira-onboarding-quickstart-core/src/utils/analytics/index.tsx';
import type { TriggersToOpenChecklist } from '../../common/types.tsx';

// We tend to combine flows of openChecklist from both minimised and dismissed

type OpenChecklistProps = {
	trigger: TriggersToOpenChecklist;
	openTask?: string;
};

export const useOpenChecklist = () => {
	const [
		{ openTask: currentOpenTask },
		{ nextSetChecklistIsOpen, nextSetChecklistIsDismissed, nextOpenTask },
	] = useJswOnboarding();
	const { openRightSidebar } = useRightSidebarController();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [quickstartStatus] = useQuickstartUiStatus();
	const currentRightSidebarState = useActiveRightSidebarState();

	const currentPanelId = currentRightSidebarState?.panelId;

	const openChecklist = ({ trigger, openTask }: OpenChecklistProps) => {
		if (openTask && openTask !== currentOpenTask) {
			nextOpenTask(openTask);
		}

		openRightSidebar(PANEL_ID, PANEL_WIDTH, false, true);

		fireAnalyticsOnOpenRightHandSidebar(createAnalyticsEvent, {
			quickstartStatus,
			currentRightSidebarPanelId: currentPanelId || '',
			openRightSidebarToTop: true,
			trigger,
		});
		if (quickstartStatus === QUICKSTART_UI_STATUS.DISMISSED) {
			nextSetChecklistIsDismissed(false);
		} else {
			nextSetChecklistIsOpen(true);
		}
	};

	return openChecklist;
};
